import { ComponentProps } from "react";

import PageHeader from "@ds-developer/page-header";

import { Message as FormattedMessage } from "@ds-developer/chat-list/dist/types";

import { Message } from "./types";

export const pageHeaderPropsMap: Record<
  string,
  ComponentProps<typeof PageHeader>
> = {
  messages: {
    title: "Message centre",
    breadcrumbs: [
      {
        title: "Home",
        link: "/",
      },
      {
        title: "Messages",
        link: "/messages",
      },
    ],
  },
  news: {
    title: "Driving School news feed",
    breadcrumbs: [
      {
        title: "Home",
        link: "/",
      },
      {
        title: "Messages",
        link: "/messages",
      },
      {
        title: "News",
      },
    ],
  },
  "tech-updates": {
    title: "Tech updates",
    breadcrumbs: [
      {
        title: "Home",
        link: "/",
      },
      {
        title: "Messages",
        link: "/messages",
      },
      {
        title: "Tech updates",
      },
    ],
  },
};

export const formatMessageObjects = (
  messages: Message[],
  instructorName: string,
): FormattedMessage[] =>
  messages.map(
    (message: Message): FormattedMessage => ({
      message: { body: message.body, createdAt: new Date(message.created) },
      sender: {
        name: message.from === 1 ? instructorName : "Agent",
        type: message.from === 1 ? "user" : "contact",
      },
    }),
  );
